// extracted by mini-css-extract-plugin
module.exports = {"aroffPCHeader":"portfolio_aroffPCHeader__36YMm","arroffPCCell":"portfolio_arroffPCCell__VdvCf","arroffPCCellInTotal":"portfolio_arroffPCCellInTotal__LHEPc"};